
import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import highResDesktopImageWebp from './images/podcast-hero-desktop.webp';
import highResTabletImageWebp from './images/podcast-hero-tablet.webp';
import highResMobileImageWebp from './images/podcast-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import {
  HeroSectionStyled,
  TypographyStyled,
} from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='podcast-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Podcast'
      headingText={
        <>
          Let&#39;s talk about{' '}
          <TypographyStyled
            component='span'
            italic>
            A Better Way <WidowBlock>to Money&#174;</WidowBlock>
          </TypographyStyled>
        </>
      }
      descriptionText={
        <>
          Do you find yourself asking &#34;Is there a better way to save, spend, splurge, invest, or retire&#63;&#34; Find the answers to those questions, and more, with our award&#45;winning podcast&#8212;
          <TypographyStyled
            component='span'
            italic>
            A Better Way to Money&#174;.
          </TypographyStyled>
          {' '}We&#39;ll help you uncover financial blind spots and find opportunities as you navigate life&#39;s big (and small) moments.
        </>
      }
      ctaPrimary={{
        linkUrl: 'https://link.cohostpodcasting.com/8db6f862-af69-4a11-9165-5b7d32356dee?d=sa1qLxFmW',
        buttonText: 'Listen now',
        ariaLabel: 'Listen to the Better Way to Money podcast',
        children: '',
        isOutgoingLink: true,
      }}
      backgroundImageAriaLabel='Two steaming coffee cups'
      backgroundImageDesktop={highResDesktopImageWebp.toString()}
      backgroundImageTablet={highResTabletImageWebp.toString()}
      backgroundImageMobile={highResMobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );};
